/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
const RichTextField = ({ children }) => {
    return <div dangerouslySetInnerHTML={{ __html: children }} />;
};

export default RichTextField;
